import { Device, AuthCode, AuthUniqueCode } from '../models/device.model';
import { MfaDeviceService } from '../services/mfa-device.service';
/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */
import { Component, ViewEncapsulation, OnDestroy, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';

// UI Actions
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'activate-device',
    encapsulation: ViewEncapsulation.Emulated,
    template: require('./activate-device.component.html'),
    styles: [
        `
            .modal .modal-dialog.modal-lg {
                max-width: 400px;
            }
            .modal-title {
                font-weight: 400;
            }
            .img-thumbnail {
                width: 200px;
            }
            .device {
                font-size: 26px;
            }
            .toggle-custom {
                font-weight: 500;
                color: #f04e18;
                cursor: pointer;
            }
            .note-custom-text {
                font-size: 0.75rem;
                color: #888;
            }
            .custom-unique-code {
                background-color: #f4f3f3;
                border: 1px solid #cac7c7;
                padding: 10px 0;
                border-radius: 0.25rem;
                font-size: 1.2rem;
            }
        `,
    ],
})
export class ActivateDeviceComponent implements OnDestroy {
    @ViewChild('registerDevice') step1Template: ElementRef;
    @Output() rowsUpdated: EventEmitter<any> = new EventEmitter<any>();

    public device: Device[];
    public closeResult: string;
    public pollSubscription: Subscription;
    public authCodeImage: string = '';
    public authCode: string = '';
    public currentStep: number;
    public modalLoading: boolean = false;
    public showUniqueCode: boolean = false;
    public deviceStatus: string;
    public deviceNickname: string;
    private config = process.env.config;

    constructor(private modalService: NgbModal, private mfaDeviceService: MfaDeviceService) {}

    public openActivateDeviceStep1() {
        this.currentStep = 1;
        this.deviceNickname = null;
        this.deviceStatus = null;

        this.modalService
            .open(this.step1Template, {
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.pollingCleanup();
                },
                (reason: any) => {
                    this.pollingCleanup();
                }
            );
    }

    public setNickname(deviceNickname: string) {
        this.deviceNickname = deviceNickname;
        if (this.deviceNickname) {
            this.openStep2();
        }
    }

    public openStep2() {
        this.toggle(false);
        this.getQRCode();
    }

    public retryStep() {
        this.toggle(false);
        this.getQRCode();
    }
    public toggleAndGetQRCode() {
        this.getQRCode();
        this.toggle();
    }

    public toggleAndGetUniqueCode() {
        this.getUniqueCode();
        this.toggle();
    }

    public getQRCode() {
        this.setStep2Defaults();
        this.pollingCleanup();

        this.mfaDeviceService.getQRCode(this.deviceNickname).subscribe((response: AuthCode) => {
            this.authCodeImage = `data:${response.contentType};base64,` + response.qrCodeBase64;
            this.pollEnrollDeviceActive();
            this.modalLoading = false;
        }),
            () => {
                this.deviceStatus = 'error';
                this.modalLoading = false;
                this.pollingCleanup();
            };
    }

    public getUniqueCode() {
        this.setStep2Defaults();
        this.pollingCleanup();

        this.mfaDeviceService.getUniqueCode(this.deviceNickname).subscribe((response: AuthUniqueCode) => {
            this.authCode = response.key;
            this.pollEnrollDeviceActive();
            this.modalLoading = false;
        }),
            () => {
                this.deviceStatus = 'error';
                this.modalLoading = false;
                this.pollingCleanup();
            };
    }
    public pollEnrollDeviceActive() {
        this.getEnrollDevice();

        this.pollSubscription = Observable.interval(this.config.feature.deviceActive.pollingInterval).subscribe(this.getEnrollDevice.bind(this));
    }

    public setTableData(data: Device[] = []) {
        this.pollingCleanup();
        this.rowsUpdated.emit(data);
        this.modalLoading = false;
    }

    private getEnrollDevice() {
        this.mfaDeviceService.getMfaDevice().subscribe(
            (data: Device[]) => {
                if (data.length && data[0].status.toLowerCase() === 'active') {
                    this.setTableData(data);
                    this.deviceStatus = 'success';
                } else if (!data.length) {
                    this.pollingCleanup();
                    this.deviceStatus = 'error';
                }
            },
            (err: any) => {
                this.deviceStatus = 'error';
                this.pollingCleanup();
            }
        );
    }

    public ngOnDestroy() {
        this.pollingCleanup();
    }

    public toggle(show?: boolean) {
        if (show === true || show === false) {
            this.showUniqueCode = show;
        } else {
            this.showUniqueCode = !this.showUniqueCode;
        }
    }
    public setStep2Defaults() {
        this.currentStep = 2;
        this.deviceStatus = null;
        this.modalLoading = true;
    }
    private pollingCleanup() {
        // unsubscribe to ensure no memory leaks
        if (this.pollSubscription) {
            this.pollSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/manage-mfa-device/activate-device/activate-device.component.ts